export let BASE_URL = window.publicConfig.url;
export let BASE_NOTIFY_URL = window.publicConfig.urlNotify;
export let BASE_URL_WORLDWFONE = window.publicConfig.urlWorldfone;
export let BASE_URL_WORLDWFONE_LOCAL = window.publicConfig.urlWorldfonelocal;
export let SECRETKEY_WORLDWFONE = window.publicConfig.secretWorldfone;
export let VERSION = window.publicConfig.version;
export let KHAMBENH_NAME = window.publicConfig.khambenh;
export let CDHA_NAME = window.publicConfig.cdha;